"use client";

import { FC, useCallback, useContext, useEffect, useMemo, useState } from "react";

import { SearchContext, ISearchContext } from "context";

import { SearchPagination } from "./SearchPagination";

export const SearchPaginationContainer: FC = () => {
  const { searchData, setSearchData } = useContext(SearchContext) as ISearchContext;

  const [pageCount, setPageCount] = useState(0);

  useEffect(() => {
    setPageCount(Math.ceil(searchData.total / searchData.itemsPerPage));
  }, [searchData.itemsPerPage, searchData.total]);

  const handlePageClick = useCallback(
    (event: { selected: number }) => {
      const newOffset = event.selected * searchData.itemsPerPage;
      setSearchData({ ...searchData, offset: newOffset });
    },
    [searchData, setSearchData],
  );

  const forcePage = useMemo(
    () =>
      Math.min(Math.floor(searchData.offset / searchData.itemsPerPage), Math.max(0, pageCount - 1)),
    [searchData.offset, searchData.itemsPerPage, pageCount],
  );

  const searchOffsetFrom = useMemo(() => searchData.offset + 1, [searchData.offset]);
  const searchOffsetTo = useMemo(
    () =>
      searchData.total - searchData.offset + 1 < searchData.itemsPerPage
        ? searchData.total
        : searchData.offset + searchData.itemsPerPage,
    [searchData.offset, searchData.itemsPerPage, searchData.total],
  );

  if (searchData.itemsPerPage >= searchData.total) return null;

  return (
    <SearchPagination
      info={
        <>
          <strong>
            {searchOffsetFrom}
            {searchOffsetTo && `-${searchOffsetTo}`}
          </strong>{" "}
          van {searchData.total}
        </>
      }
      pageCount={pageCount}
      forcePage={forcePage}
      handlePageClick={handlePageClick}
    />
  );
};
